import { viewAliases } from "../prototypeData";
import type { PrototypeState } from "../controllerState";
import type { PrototypeRuntime, Root } from "../prototypeTypes";
import { recordRuntimeError } from "../prototypeRuntimeSupport";

export async function loadViewData(rawView: string, runtime: PrototypeRuntime, state: PrototypeState, root?: Root) {
  const view = viewAliases[rawView] ?? rawView;
  try {
    // View hydration is now centralized in navigationController.showView().
    // This loader only handles data prefetch that showView() doesn't cover.
    if (view === "profile") await runtime.api.getSession();
	// Subscription surfaces mount once during runtime hydration. Do not repaint
	// individual gates here: that would create a second subscription renderer.
	void root;
  } catch (error) {
    recordRuntimeError(runtime, error);
  }
}
